<template>
	<div class="md-layout">
		<div class="md-layout-item md-medium-size-50 md-size-50">
			<h4>{{translate(locale.settings)}}</h4>
		</div>
		<div class="md-layout-item md-medium-size-100 md-size-100">
			<md-card>
				<md-card-content>
					<loading v-if="!loaded" />
					<div v-if="loaded">
						<md-table>
							<md-table-row>
								<md-table-head></md-table-head>
								<md-table-head>{{translate(locale.settingName)}}</md-table-head>
								<md-table-head>{{translate(locale.settingValue)}}</md-table-head>
								<md-table-head>{{translate(locale.action)}}</md-table-head>
							</md-table-row>
							<md-table-row v-for="(setting, index) in settingsList">
								<md-table-cell>{{index + 1}}</md-table-cell>
								<md-table-cell>{{translate(setting.name)}}</md-table-cell>
								<md-table-cell>
									<md-field>
										<md-input type="text" v-model="settingsList[index].value"
											:value="settingsList[index].value" @keyup="">
										</md-input>
									</md-field>
								</md-table-cell>
								<md-table-cell>
									<md-button class="md-just-icon md-simple md-success" @click="onUpdate(setting)">
										<md-icon>done</md-icon>
										<md-tooltip md-direction="top">{{translate(locale.update)}}</md-tooltip>
									</md-button>
								</md-table-cell>
							</md-table-row>
						</md-table>
					</div>
				</md-card-content>
			</md-card>
		</div>
	</div>

	</div>

</template>

<script>
	export default {
		created() {
			this.searchHandler();
		},
		data() {
			return {
				loaded: false, settingsList: []
			}
		},
		methods: {
			searchHandler(more = false) {
				this.$http.get(this.config.api + "/admin/settings").then(data => {
					this.settingsList = data.body.data;
					this.loaded = true;
				})
			},
			onUpdate(setting) {

				this.$http.post(this.config.api + "/admin/settings/update", {
					setting: setting
				}).then(res => {
					if (res.body.status == 'success') {
						this.$notification.notify({
							message: "Updated successfully.||កែប្រែបានជោគជ័យ។",
							icon: 'done',
							type: 'success'
						})
						this.searchHandler();
					}
				})
			}
		}
	}
</script>
<style scoped>
	.product-thumbnail {
		width: 64px;
		height: 64px;
	}

	.grid-8 {
		text-align: center;
		max-width: 20%;
		min-width: 20%;
		flex: 0 0 20%;
	}

	.thumb-product {
		width: 50%;
	}
</style>


// WEBPACK FOOTER //
// src/pages/Settings/View.vue